import {
  getCurrentFbUser,
  handleAuthStateChanged,
  signInWithCustomToken,
} from './auth';
import { fetchJson } from '../fetch';
import { User, AuthError } from 'firebase/auth';

export type onChangeProp = (user: User | null) => void;

type ErrorProp = {
  response: Response;
  json: Object | null;
  error: AuthError | Error | null;
  messages: Array<string>;
};

export type onErrorProp = (data: ErrorProp) => void;
export type Unsubscribe = () => void;

const callbacks = {};

let keyInt = 0;
let dispatch = false;

const trigger = (callback) => Object.values(callbacks).forEach(callback);

// Observe the user authentication state
// Return unsubscribe function
const observeUserAuthChange =
  (tokenApiPath: string) =>
  (onChange: onChangeProp, onError: onErrorProp): Unsubscribe => {
    const key = keyInt.toString();
    callbacks[key] = { onChange, onError };
    if (dispatch) {
      // Call success callback when observer has been already triggered
      const user = getCurrentFbUser();
      onChange(user);
    } else {
      callbacks[key].unsubscribe = handleAuthStateChanged(
        (user) => {
          trigger(({ onChange }) => onChange(user));
          // Fetch the custom token to let the user sign in
          fetchJson(tokenApiPath, {
            onSuccess: ({ json: { token } }) => signInWithCustomToken(token),
            onError: ({ response, json, error, messages = [] }) =>
              trigger(({ onError }) =>
                onError?.({ response, json, error, messages }),
              ),
          });
        },
        (error: AuthError) => trigger(({ onError }) => onError?.({ error })),
      );

      dispatch = true;
    }

    keyInt++;

    // Unsubscribe function
    return () => {
      // Unsubscribe the onAuthStateChanged
      callbacks[key]?.unsubscribe?.();
      delete callbacks[key];
    };
  };

export default observeUserAuthChange;
